import { computePositionChangesFromSessions } from '../../shared/leaderboardShared';
import { CONSOLE_PLAYERS, PC_PLAYERS } from './platformPlayers';

const PLATFORM_BY_ID = new Map();
PC_PLAYERS.forEach(([epicId, wlsId]) => {
    PLATFORM_BY_ID.set(epicId, 'pc');
    PLATFORM_BY_ID.set(wlsId, 'pc');
});
CONSOLE_PLAYERS.forEach(([epicId, wlsId]) => {
    PLATFORM_BY_ID.set(epicId, 'console');
    PLATFORM_BY_ID.set(wlsId, 'console');
});

export function getMemberPlatform(member) {
    const epicId = String(member?.ingame_id || '').trim().toLowerCase();
    return PLATFORM_BY_ID.get(epicId) || PLATFORM_BY_ID.get(String(member?.id || '')) || null;
}

export function getTeamPlatform(members) {
    const platforms = new Set((members || []).map(getMemberPlatform).filter(Boolean));
    if (platforms.size === 0) return null;
    if (platforms.size > 1) return 'mixed';
    return platforms.values().next().value;
}

function createRandom(seed) {
    let state = seed;
    return () => {
        state = (state * 1664525 + 1013904223) % 4294967296;
        return state / 4294967296;
    };
}

function placementPoints(place) {
    if (place === 1) return 25;
    if (place <= 5) return 15;
    if (place <= 15) return 8;
    if (place <= 25) return 3;
    return 0;
}

function buildDemoTeams() {
    const toMember = ([epicId, wlsId, name]) => ({ id: wlsId, name, ingame_id: epicId, ingame_name: name });
    const pairs = (players) => {
        const teams = [];
        for (let index = 0; index < players.length; index += 2) {
            teams.push(players.slice(index, index + 2).map(toMember));
        }
        return teams;
    };
    return [...pairs(CONSOLE_PLAYERS), ...pairs(PC_PLAYERS)];
}

let demoTick = 0;

export function fetchDemoLeaderboardData() {
    demoTick += 1;
    const games = 3 + (demoTick % 3);
    const teams = buildDemoTeams();
    const rows = [];
    const teamDetails = {};

    teams.forEach((members, teamIndex) => {
        const random = createRandom(teamIndex * 7919 + 17);
        const sessions = Array.from({ length: games }, () => ({
            place: 1 + Math.floor(random() * random() * 50),
            kills: Math.floor(random() * 9),
        })).map((session) => ({ ...session, points: placementPoints(session.place) + session.kills * 2 }));

        const teamname = members.map((member) => member.name).join(' - ');
        const points = sessions.reduce((sum, session) => sum + session.points, 0);
        rows.push({
            teamname,
            elims: sessions.reduce((sum, session) => sum + session.kills, 0),
            wins: sessions.filter((session) => session.place === 1).length,
            avg_place: sessions.reduce((sum, session) => sum + session.place, 0) / games,
            games,
            points,
            place: 0,
            alive: false,
            memberData: [],
            sessionsForIndicators: sessions,
        });
        teamDetails[teamname] = { members, sessions, teamData: { points } };
    });

    rows.sort((a, b) => (b.points - a.points) || (b.wins - a.wins) || (b.elims - a.elims) || a.teamname.localeCompare(b.teamname));
    rows.forEach((row, index) => {
        row.place = index + 1;
        teamDetails[row.teamname].teamData.place = row.place;
    });
    const positionChanges = computePositionChangesFromSessions(rows);

    return {
        leaderboard: rows.map((row) => ({ ...row, positionChange: positionChanges[row.teamname] ?? null })),
        teamDetails,
        totalPages: 1,
        showPositionIndicators: true,
    };
}
